// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21bGz","input":"styles_input__1_-n6"};